import React from "react";
import { Container } from "react-bootstrap";
import { GiWheat } from "react-icons/gi";
import "../../../assets/css/customer/business/process/Process.css";
import register from "../../../assets/images/business/register.jpeg";
import grow from "../../../assets/images/business/grow.jpg";
import startWork from "../../../assets/images/business/startWork.webp";
import verifictaion from "../../../assets/images/business/verifictaion.webp";
// ── Arrow SVG — same curved up-right for all 3 gaps ──────────
const ArrowRight = () => (
  <svg
    className="wp-arrow"
    viewBox="0 0 90 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 44 C 20 44, 30 10, 60 14 C 72 16, 78 22, 84 18"
      stroke="rgba(255,255,255,0.75)"
      strokeWidth="2.2"
      strokeLinecap="round"
      fill="none"
    />
    <path
      d="M76 12 L 85 18 L 76 24"
      stroke="rgba(255,255,255,0.75)"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
);

const steps = [
  {
    id: "01",
    title: "Create Your Account",
    desc: "Register on KisaanMart and create your profile to get started.",
    image: register,
  },
  {
    id: "02",
    title: "Complete Verification",
    desc: "Submit the required information and complete the verification process.",
    image: verifictaion,
  },
  {
    id: "03",
    title: "Start Your Work",
    desc: "Use your dashboard to manage your products, orders, or delivery tasks.",
    image: startWork,
  },
  {
    id: "04",
    title: "Grow & Earn",
    desc: "Complete your tasks and use KisaanMart to grow your opportunities.",
    image: grow,
  },
];

const Process = () => {
  return (
    <section className="wp-section">
      <div className="wp-overlay" />

      <Container className="wp-container">
        {/* ── Header ── */}
        <div className="wp-header">
          {/* <div className="wp-tag">
            <GiWheat className="wp-tag-icon" />
            <span>BECOME A SELLER</span>
          </div> */}
          <h2 className="wp-title">
            Join KisaanMart &amp;
            <br />
            Start Earning Today
          </h2>
          <p className="wp-subtitle">
            Join KisaanMart and become part of our growing agricultural
            marketplace. Create your account, complete verification, and get
            started with ease.
          </p>
        </div>

        {/* ── Cards Row ── */}
        <div className="wp-row">
          {steps.map((step, i) => (
            <React.Fragment key={step.id}>
              <div className="wp-card">
                <div className="wp-img-wrapper">
                  <img src={step.image} alt={step.title} className="wp-img" />
                  <div className="wp-badge">{step.id}</div>
                </div>
                <p className="wp-step-title">{step.title}</p>
                <p className="wp-step-desc">{step.desc}</p>
              </div>

              {i < 3 && (
                <div className="wp-arrow-wrap">
                  <ArrowRight />
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default Process;
